"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationChurnReason = exports.SubscriptionStatus = void 0;
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Cancelled"] = "cancelled";
    SubscriptionStatus["InProgress"] = "inProgress";
})(SubscriptionStatus || (exports.SubscriptionStatus = SubscriptionStatus = {}));
var CancellationChurnReason;
(function (CancellationChurnReason) {
    CancellationChurnReason["ManualDonor"] = "ManualDonor";
    CancellationChurnReason["ManualAdmin"] = "ManualAdmin";
    CancellationChurnReason["PaymentFailure"] = "PaymentFailure";
    CancellationChurnReason["MarkAsFraudulent"] = "MarkAsFraudulent";
    CancellationChurnReason["DisputeResolved"] = "DisputeResolved";
})(CancellationChurnReason || (exports.CancellationChurnReason = CancellationChurnReason = {}));
